import { motion } from "framer-motion";

const STEPS = [
  {
    n: "1",
    color: "bg-mirchi text-pav",
    title: "TAKE THE VADA PAV",
    body: "India's best-loved street snack — 2 crore+ sold across Mumbai every single day, loved across every age and income.",
  },
  {
    n: "2",
    color: "bg-chutney text-pav",
    title: "PUT IT IN A SUB",
    body: "One long masala pav, one long garma-garam vada — potato in every bite, no gaps, no lottery. Not a menu of fillings; one perfect idea, uncurled.",
  },
  {
    n: "3",
    color: "bg-gulabi text-kadak",
    title: "MAKE IT REPEATABLE",
    body: "A tight 7-item menu, a 3-person stall, standard kit. Built from day one to be franchised, not just admired.",
  },
];

export const Idea = () => (
  <section id="idea" data-testid="idea-section" className="scroll-mt-24 bg-pav py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <p className="font-bungee text-mirchi tracking-[0.35em] text-xs sm:text-sm">THE IDEA</p>
      <h2 className="mt-4 max-w-3xl font-shrikhand text-4xl sm:text-5xl lg:text-6xl leading-tight text-kadak">
        Mumbai's ₹20 icon. <span className="text-mirchi">The world's favourite format.</span>
      </h2>
      <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 30, rotate: 0 }}
            whileInView={{ opacity: 1, y: 0, rotate: i === 1 ? 1.5 : -1.5 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.45, delay: i * 0.12 }}
            className="rounded-3xl border-4 border-kadak bg-pav p-7 sticker-shadow"
          >
            <span className={`inline-flex h-11 w-11 items-center justify-center rounded-full border-4 border-kadak font-bungee text-lg ${s.color}`}>
              {s.n}
            </span>
            <h3 className="mt-5 font-anton text-xl uppercase tracking-wide">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-kadak/75">{s.body}</p>
          </motion.div>
        ))}
      </div>
      <p className="mt-12 inline-block rotate-1 font-shrikhand text-xl sm:text-2xl text-chutney">
        The Bada: poora Bombay ek haath mein.
      </p>
    </div>
  </section>
);
